
import LocalData from '../data/localData';
import { useInstance } from 'common-module/src/util/useInstance';
import { computed, ref, watch } from 'vue-demi';

export const useIdb = () => {
  const instance = useInstance();

  const localDb = ref<LocalData | undefined>(undefined);

  const useIndexDB = computed<boolean>(() =>
    instance.$store?.getters['features/isSwitch']('user:indexdb-switch')
  );

  const isIndexedDBSyncEnd = computed<boolean>(() => {
    return instance.$store?.state.indexedDB.isSyncEnd;
  });

  watch(useIndexDB, (value) => {
    if (value) {
      localDb.value = new LocalData(instance.$iDB, isIndexedDBSyncEnd.value);
    }
  }, { immediate: true });

  watch(
    () => isIndexedDBSyncEnd.value,
    (value) => {
      localDb.value?.setUseIndexedDB(value);
    }
  );

  return {
    localDb
  };

};
